
export const SET_BOLETIM= 'BACKUP_BOLETIM';